import React from 'react';
import { Text } from '@adc/parallax-component-library';
import styled from 'styled-components';
const BtnWrapper = styled.button `
  border: none;
  background: none;
  padding: 0;
  margin: auto;
  display: flex;
  justify-content: 'center';
  cursor: pointer;
`;
const Link = ({ children, onPress, disabled, testID, IconElement, linkTextColor = '$interactive.tertiary.enabled.onColor', ...rest }) => {
    return (React.createElement(BtnWrapper, { id: testID, onClick: onPress, disabled: disabled, ...rest },
        IconElement && (React.createElement(IconElement, { color: "$interactive.tertiary.enabled.onColor", testID: `${testID}-icon` })),
        React.createElement(Text, { marginLeft: "$2", fontSize: "$bodyBase.strong", fontWeight: "$bodyBase.strong", color: linkTextColor, testID: `${testID}-label` }, children)));
};
export { Link };
